import React, {useEffect} from "react"
import {useLocal, useRoomSetup, useRoomParameters, useModal, useSolution} from "../../AppContext"
import {Button, ButtonText} from "../../Components/Button"
import style from "./ViewImpressions.css"

export const ViewImpressions = ({suggestedSolutions}) => {
    useEffect(() => {
        suggestedSolutions.reset()
    }, [])

    return <>
        <div>
            <Header/>
            <Impressions/>
        </div>
        <Footer suggestedSolutions={suggestedSolutions}/>
    </>
}

const Header = () => {
    const local = useLocal()
    return <div className={style.header}>
        <div dangerouslySetInnerHTML={{__html: local.__("Was gefällt Ihnen?")}}/>
        <div dangerouslySetInnerHTML={{__html: local.__("Damit wir Ihnen die ferfekten Schallabsorber vorschlagen können, die nicht nur akustisch wirken, sondern Ihnen auch optisch gefallen, brauchen wir noch einmal Ihre Hilfe. <strong>Markieren Sie aus der folgenden Auswahl beliebig viele Bilder, die Ihren Geschmack treffen!</strong>")}}/>
    </div>
}

const Impressions = () => {
    const roomSetup = useRoomSetup()
    const roomParameters = useRoomParameters()

    return <div className={style.list}>
        {roomParameters.getImpressions(roomSetup.getType()).map(impression => <Impression key={impression.id} impression={impression}/>)}
    </div>
}

const Impression = ({impression}) => {
    const roomSetup = useRoomSetup()
    const local = useLocal()

    const onClick = () => {
        roomSetup.toggleImpression(impression.id)
    }

    return <div onClick={onClick}>
        <img src={impression.image} alt={local.getLabel(impression.title)} />
        <div>
            {roomSetup.hasImpression(impression.id) && <div/>}
        </div>
    </div>
}

const Footer = ({suggestedSolutions}) => {
    const local = useLocal()
    const modal = useModal()
    const roomSetup = useRoomSetup()
    const solution = useSolution()
    const roomParameters = useRoomParameters()

    const onNext = async () => {
        suggestedSolutions.stepNext()
    }

    const emptyRoom = () => {
        const roomName = local.getLabel(roomParameters.getRoomTypeByCode(roomSetup.getType()).name)
        solution.addPlanning([], roomName)
        modal.close()
    }

    return <div className={style.footer}>
        <div className={style.prompt}>

        </div>
        <div className={style.action}>
            <ButtonText onClick={emptyRoom}>{local.__("mit leerem Raum starten")}</ButtonText>
            <Button onClick={onNext}>{local.__("Los geht's")}</Button>
        </div>
    </div>
}
